import React from 'react';
import { useHomeHook } from './Hooks';
import HomeComponent from './Component';

const Home = () => {
  return <HomeComponent {...useHomeHook()} />
}
export default Home;
